import user from '@/api/administrator/dealer-user'
import dealer from '@/api/administrator/dealer-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return user.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return user.store(data)
  },
  update(context, { id, data }) {
    return user.update(id, data)
  },
  destroy(context, { id, data }) {
    return user.destroy(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await game.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getDealer(context, attrubutes = {}) {
    return dealer.get({
      params: attrubutes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  resetpwd(context, data){
    return user.resetpwd(data)
  }
}